import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';
import type { HelpdeskNotificationSettingsFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/helpdesk-notification-settings.dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HelpDeskSettingsService extends BaseService {
  protected baseUrl = '/helpdesk/settings';

  public getNotificationSettings(): Observable<HelpdeskNotificationSettingsFindInterface> {
    return this.http.get<HelpdeskNotificationSettingsFindInterface>(`${this.baseUrl}/notification-settings`);
  }

  public updateNotificationSettings(body: HelpdeskNotificationSettingsFindInterface): Observable<HelpdeskNotificationSettingsFindInterface> {
    return this.http.patch<HelpdeskNotificationSettingsFindInterface>(`${this.baseUrl}/notification-settings`, body);
  }

  public getDefaultClient(): Observable<ClientFindInterface> {
    return this.http.get<ClientFindInterface>(`${this.baseUrl}/client`);
  }

  public setDefaultClient(id: number): Observable<ClientFindInterface> {
    return this.http.put<ClientFindInterface>(`${this.baseUrl}/client/${id}`, {});
  }

  public getDefaultContragent(): Observable<ContragentFindInterface> {
    return this.http.get<ContragentFindInterface>(`${this.baseUrl}/contragent`);
  }

  public setDefaultContragent(id?: number): Observable<ContragentFindInterface> {
    return this.http.put<ContragentFindInterface>(`${this.baseUrl}/contragent/${id}`, {});
  }
}
